<template>
  <a-form-item>
    <span
      v-if="selectDatas.length > 1"
      class="label-title"
    >{{ index !== 0 ? $t('message["1747"]') : '' }}</span>
    <a-cascader
      v-decorator="[
        `${item.join('-')}${index}}`,
        {
          initialValue:item,
        }
      ]"
      :field-names="{ label: typeLabel.label , value: typeLabel.value, children: typeLabel.children }"
      :options="index === 0 ? options: newFromDatas"
      :change-on-select="index === 0"
      popup-class-name="from-info-cascader"
      :placeholder="placeholderTit"
      @change="getValue"
      @popupVisibleChange="popupVisibleChange"
    />
    <i
      v-if="index !== 0"
      class="iconfont iconicon-test8"
      @click="delItem"
    />
  </a-form-item>
</template>
<script>
import { mapState, mapMutations } from 'vuex'

export default {
  props: {
    item: {
      type: Array,
      default () {
        return []
      }
    },
    selectDatas: {
      type: Array,
      default () {
        return []
      }
    },
    index: {
      type: Number,
      default () {
        return 0
      }
    },
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      isBtnShow: false
    }
  },
  computed: {
    ...mapState('statistic', ['fromDatas', 'newFromDatas']),
    typeLabel () {
      if (this.isDev) {
        return {
          label: 'fieldname',
          value: 'fieldkey',
          children: 'child'
        }
      } else {
        return {
          label: 'name',
          value: 'id',
          children: 'child'
        }
      }
    },
    isDev () {
      return this.type && this.type === 'dev'
    },
    options () {
      const { fromDatas = [] } = this
      if (!this.isDev) {
        fromDatas.forEach(item => {
          if (item.children && item.children.length > 0) {
            item.child = item.children
          }
        })
        return fromDatas
      } else {
        return fromDatas
      }
    },
    placeholderTit () {
      return this.isDev ? this.$t('message["887"]') : this.$t('message["1771"]')
    }
  },
  methods: {
    ...mapMutations('statistic', ['setNewFromDatas']),
    getValue (value, getValue) {
      if (this.index === 0) {
        this.selectDatas.splice(0)
      }
      if (this.isDev) {
        if (value.length === 1) {
          const arry = JSON.parse(JSON.stringify(getValue))
          this.selectDatas.splice(0)
          this.selectDatas.push(value)
          this.setNewFromDatas(arry)
          this.$emit('setShow', false)
        } else if (value.length === 2) {
          this.selectDatas[this.index] = value
        } else {
          this.selectDatas[this.index] = value
          this.handleDisabled(value[1], true)
          this.$emit('setShow', true && !this.isAllDisabled())
        }
      } else {
        this.selectDatas[this.index] = value
      }
    },
    handleDisabled (val, b) {
      if (this.newFromDatas.length > 0 && this.newFromDatas[0].child) {
        this.newFromDatas[0].child.forEach(item => {
          if (val === item.fieldkey) {
            item.disabled = b
          } else {
            if (this.index === 0) {
              item.disabled = false
            }
          }
        })
      }
    },
    popupVisibleChange (val) {
      if (this.item.length > 1) {
        if (val) {
          this.handleDisabled(this.item[1], false)
        } else {
          this.handleDisabled(this.item[1], true)
        }
      }
    },
    delItem () {
      this.selectDatas.splice(this.index, 1)
      if (this.item.length > 1) {
        this.handleDisabled(this.item[1], false)
      }
      this.$emit('setShow', !this.isAllDisabled())
    },
    isAllDisabled () {
      const { newFromDatas = [] } = this
      if (newFromDatas.length > 0 && newFromDatas[0].child) {
        return newFromDatas[0].child.every(item => !!item.disabled)
      }
    }
  }
}
</script>
<style lang="scss">
.from-info-cascader {
  .ant-cascader-menu-item-disabled {
      display: none;
    }
}
</style>
